import axios from "axios";

const registerCallRetell = async (agentId, voiceId) => {
  try {
    try {
      const voiceObj = {
        agentConfig: { voice_id: voiceId }
      };
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/start-call`,
        voiceObj,
        {
          headers: {
            "agentX-ID": agentId,
            "Content-Type": "application/json"
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error("Conversation error:", error.message);
      throw error;
    }
  } catch (err) {
    throw err;
  }
};

export default registerCallRetell;
